import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';
import { renderDateViewCalendar } from '@mui/x-date-pickers/dateViewRenderers';

import { EditableDateTimePickerToolbar } from './EditableTimePickerToolbar/EditableTimePickerToolbar';

export const KeyboardDateTimePicker = (props: DateTimePickerProps<any>) => {
  const toolbarSlotProps =
    typeof props.slotProps?.toolbar === 'object' && props.slotProps.toolbar !== null
      ? props.slotProps.toolbar
      : {};

  return (
    <DateTimePicker
      {...props}
      // Keep time editing in the custom toolbar; calendar handles date only.
      views={['year', 'month', 'day']}
      orientation="portrait"
      // Avoid the desktop two-column date+digital-clock layout.
      viewRenderers={{
        day: renderDateViewCalendar,
        month: renderDateViewCalendar,
        year: renderDateViewCalendar,
        hours: null,
        minutes: null,
        seconds: null,
      }}
      slots={{
        toolbar: EditableDateTimePickerToolbar as any,
        ...props.slots,
      }}
      slotProps={{
        ...props.slotProps,
        toolbar: {
          ...toolbarSlotProps,
          // Desktop DateTimePicker hides the toolbar by default.
          hidden: false,
        },
        actionBar: {
          ...(typeof props.slotProps?.actionBar === 'object' && props.slotProps.actionBar !== null
            ? props.slotProps.actionBar
            : {}),
          actions: ['accept'],
        },
      }}
    />
  );
};
